import React, { useEffect } from "react";
import {
  Button,
  Checkbox,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  Row
} from "react-bootstrap";

import ButtonLoader from "../../../ButtonLoader";
import ShowNotification from "../../../Notification/LoadableShowNotification";
import SocialLogin from "../../../SocialLogin/LoadableSocialLogin";

const queryString = window.location.search;
const queryParams = new URLSearchParams(queryString);

let allowSSO = queryParams.get("sso");
const showSignupForm = queryParams.get("form");

function LoginForm(props) {
  useEffect(() => {
    if (props.showLoginForm) {
      if (document.getElementById("email")) {
        document.getElementById("email").focus();
      }
    }
  }, [props.showLoginForm]);

  const {
    showLoginForm,
    showLoginButton,
    showNextButton,
    loginError,
    isLoading,
    emailError,
    closeLoginError,
    closeEmailError,
    domainError,
    closeDomainError,
    downLoadError,
    closeDownloadError,
    loginType,
    login,
    formSubmitted,
    errors,
    showForm,
    handleInputChange,
    handleNextButton,
    handleChangeEmail,
    handleCheck,
    rememberMe,
    sso,
    ssoLogin,
    accountBlockError,
    isAccountBlocked,
    onSocialLogin
  } = props;

  return (
    showLoginForm && (
      <React.Fragment>
        <div className="Login">
          {!!!loginType && (
            <div className="signup-form">
              <h1 className="sign-in-heading">Sign in to your account</h1>
              <section id="TermsAndConditions">
                <span>
                  Don't have an account yet?{" "}
                  <a href="#/">
                    <span
                      onClick={() => {
                        window.location.host === "platform.zonkafeedback.com"
                          ? window.location.search === ""
                            ? (window.location =
                                "https://www.zonkafeedback.com/free-trial-signup")
                            : showSignupForm && showSignupForm == "signup"
                            ? showForm("signup")
                            : (window.location =
                                "https://www.zonkafeedback.com/free-trial-signup")
                          : showForm("signup");
                      }}
                      className="signLink"
                    >
                      Sign up for Free.
                    </span>
                  </a>
                </span>
              </section>
            </div>
          )}
          {/* {loginError && (
            <ShowNotification
              closeError={closeLoginError}
              errorHeading={`Invalid details!`}
              errorDesc={`Email address or password is incorrect. Please try again.`}
            />
          )} */}

          {emailError && (
            <ShowNotification
              closeError={closeEmailError}
              errorHeading={`Invalid details!`}
              errorDesc={`Email address is incorrect. Please try again.`}
            />
          )}

          {domainError && (
            <ShowNotification
              closeError={closeDomainError}
              errorHeading={`Invalid redirect URL.`}
              errorDesc={`Please provide correct redirect URL.`}
            />
          )}

          {downLoadError && (
            <ShowNotification
              closeError={closeDownloadError}
              errorHeading={`You don't have access to this account.`}
              errorDesc={`Seems you are not an authorized user for this account.`}
            />
          )}

          <section className="login-form mar_pointt">
            {!!!loginType && (
              <Row>
                <form onSubmit={login} id="login-form" method="post">
                  <FormGroup
                    controlId="email"
                    className="st--margn-twenty"
                    validationState={
                      formSubmitted
                        ? errors.email
                          ? "error"
                          : "success"
                        : null
                    }
                  >
                    <ControlLabel>
                      Email Address <span className="star">*</span>
                    </ControlLabel>
                    <FormControl
                      // autoFocus
                      className="email-field"
                      type="text"
                      // name="email"
                      name="txtEmail"
                      // placeholder="Enter your email address"
                      onChange={handleInputChange}
                      disabled={!showNextButton && !loginType}
                    />
                    {errors.email && <HelpBlock>{errors.email}</HelpBlock>}
                    {!showNextButton && !loginType && (
                      <span
                        className="change-email"
                        onClick={() => handleChangeEmail()}
                      >
                        Change
                      </span>
                    )}
                    {showNextButton && (
                      <Button
                        type="button"
                        className="btn-style next-btn-login"
                        onClick={() => handleNextButton(true)}
                      >
                        <span className="text-name">Next</span>
                        <span className="text-next-arrow">
                          {" "}
                          <img
                            src={require("../../../../images/right-arrow-white.svg")}
                            alt="next"
                          />
                        </span>
                        {isLoading && <ButtonLoader />}
                      </Button>
                    )}
                  </FormGroup>
                  {showLoginButton && (
                    <React.Fragment>
                      <FormGroup
                        controlId="password"
                        className="re-move-margin"
                        validationState={
                          formSubmitted
                            ? errors.password
                              ? "error"
                              : "success"
                            : null
                        }
                      >
                        <ControlLabel className="labelpassword">
                          Enter Password <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="password"
                          // name="password"
                          name="txtPassword"
                          // placeholder="Password"
                          onChange={handleInputChange}
                          className="re-move-margin"
                        />
                        {errors.password && (
                          <HelpBlock>{errors.password}</HelpBlock>
                        )}
                      </FormGroup>
                      <Col sm={12} className="remember--me">
                        <FormGroup>
                          <ControlLabel className="ant-checkbox">
                            Remember Me
                            <Checkbox
                              name="rememberMe"
                              className=""
                              inline
                              onChange={handleCheck}
                              defaultChecked={rememberMe}
                              children={<span className="checkmark"></span>}
                            />
                          </ControlLabel>
                          <span
                            onClick={env => showForm("forgotpassword")}
                            className="forgotLink"
                          >
                            Forgot Password?
                          </span>
                        </FormGroup>
                      </Col>
                      {/* errorbox */}
                      {!!accountBlockError && (
                        <div className="error--box">
                          <h4>Invalid login details</h4>
                          <p>
                            You are locked out for 5 minutes due to too many
                            login attempts. We suggest you reset your password.
                          </p>
                        </div>
                      )}
                      {!!loginError && (
                        <div className="error--box">
                          <h4>Invalid login details</h4>
                          <p>
                            Entered email or password is incorrect. Please try
                            again.
                          </p>
                        </div>
                      )}
                      <Button
                        type="submit"
                        className="btn-style sign--in-button"
                        disabled={isAccountBlocked}
                      >
                        Sign in
                        {isLoading && <ButtonLoader />}
                        <span className="text-next-arrow">
                          {" "}
                          <img
                            src={require("../../../../images/right-arrow-white.svg")}
                            alt="next"
                          />
                        </span>
                      </Button>
                    </React.Fragment>
                  )}
                </form>
              </Row>
            )}

            {!!loginType && (
              <Row>
                <section id="socialLogin">
                  <div className="sso-button-top-text">
                    <section>
                      <span>Sign in with your single sign-on credentials</span>
                    </section>
                  </div>
                  <Col sm={12} className="line">
                    <span
                      onClick={ssoLogin}
                      // href={this.props.ssoUrl}
                      className={`sso`}
                    >
                      {sso === "customSaml2" ? (
                        <img
                          src={require("../../../../images/btn-login-custom.svg")}
                          alt="Custom SAML"
                        />
                      ) : (
                        ""
                      )}
                      {sso === "okta" ? (
                        <img
                          src={require("../../../../images/btn-login-okta.svg")}
                          alt="Sign in with OKTA"
                        />
                      ) : (
                        ""
                      )}
                      {sso === "azureAd" ? (
                        <img
                          src={require("../../../../images/btn-login-azure.svg")}
                          alt="Sign in with Azure AD"
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </Col>
                </section>
                <footer>
                  <div>
                    <section className="sso-button-diff-link">
                      <Row>
                        <div className="different-method-container">
                          <a
                            href="javascript:;"
                            className="different-method-link"
                            onClick={() => showForm("login")}
                          >
                            Sign in using a different method
                          </a>
                        </div>
                      </Row>
                    </section>
                  </div>
                </footer>
              </Row>
            )}
          </section>

          {!!!loginType && !window.location.search.includes("webex") && (
            <footer>
              <div>
                <section id="lineORline">
                  <Row>
                    <Col sm={5} className="line line-left">
                      <hr className="styleCustom" />
                    </Col>
                    <Col sm={2} id="or">
                      {" "}
                      OR{" "}
                    </Col>
                    <Col sm={5} className="line line-right">
                      <hr className="styleCustom" />
                    </Col>
                  </Row>
                </section>
                {/* Social Login Section */}
                <section id="socialLogin">
                  <SocialLogin
                    onResponse={res => onSocialLogin(res)}
                    signIn={true}
                  />
                </section>
                <section>
                  {showNextButton && (
                    <Button
                      type="button"
                      className="btn-style next-btn-login-sso"
                      onClick={() => showForm("ssoLogin")}
                    >
                      <span className="text-name">Sign in with SSO</span>
                      <span className="text-next-arrow">
                        {" "}
                        <img
                          src={require("../../../../images/right-arrow-blue.svg")}
                          alt="next"
                        />
                      </span>
                      {/* {isLoading && <ButtonLoader />} */}
                    </Button>
                  )}
                </section>
              </div>
            </footer>
          )}
        </div>
      </React.Fragment>
    )
  );
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Login/SubComponents/LoginForm/LoginForm.js